import {ThankYouPageStore} from '../domain/stores/ThankYouPageStore';
import {NavigationStore} from '../domain/stores/NavigationStore';
import {
  SubscriptionFrequency,
  GetOrderForTypQuery,
  PaymentOptionType,
} from '@wix/wixstores-client-storefront-sdk/dist/es/src/graphql/queries-schema';
import {ISettingsParams} from '../components/thankYouPage/settingsParams';
import {StyleParam} from '../components/thankYouPage/constants';
import {
  AdditionalFee,
  CatalogReference,
  OrderItemAction,
  OrderItemRenderingConfig,
  SelectedMembership,
} from '@wix/wixstores-graphql-schema-node';

type Awaited<T> = T extends PromiseLike<infer U> ? U : T;

export type IControllerProps = {
  thankYouPageStore: Awaited<ReturnType<ThankYouPageStore['toProps']>>;
  navigationStore: Awaited<ReturnType<NavigationStore['toProps']>>;
  ssrError: boolean;
  skipRender: boolean;
};

export type IMedialDimensions = {
  width: number;
  height: number;
};

export type IThankYouPageSettings = {
  booleans: {};
};

export type PickupAddress = {
  addressLine: string;
  city: string;
  zipCode: string;
  state: string;
  country: string;
};

export type ShippingAddress = {
  country: string | null;
  subdivision: string | null;
  fullName: string | null;
  addressLine1?: string | null;
  addressLine2: string | null;
  addressLine: string | null;
  city: string | null;
  zipCode: string | null;
  phone: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  company: string | null;
  addressesServiceId?: string | null;
};

export type BillingAddress = {
  country: string | null;
  subdivision: string | null;
  fullName: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  addressLine: string | null;
  city: string | null;
  zipCode: string | null;
  phoneNumber: string | null;
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  company: string | null;
  addressesServiceId: string | null;
};

export type StorePickup = {
  title: string;
  time: string;
  instructions: string;
  address: PickupAddress;
};
export type TrackPurchaseParams = {
  origin: string;
  id: number;
  buyerId: string;
  buyerMail: string;
  coupon: string;
  currency: string;
  orderId: string;
  revenue: number;
  shipping: number;
  tax: number;
  contents: {
    id: string;
    sku: string;
    name: string;
    price: number;
    quantity: number;
    currency: string;
    category: string;
  }[];
};

export type Option = {
  title: string;
  isFreeText: boolean;
  description: string;
};

export type Media = {
  altText: string;
  mediaType: string;
  url: string;
  height: number;
  width: number;
};

export type Item = {
  productId: string;
  sku: string;
  catalogReference?: CatalogReference;
  name: string;
  price: number;
  quantity: number;
  productType: string;
  digitalFileLink?: string;
  paymentOption?: PaymentOptionType;
  media: Media;
  options: Option[];
  formattedPrice: string;
  formattedTotal: string;
  actions?: OrderItemAction[];
  renderingConfig?: OrderItemRenderingConfig;
  formattedDepositAmount?: string;
  selectedMembership?: SelectedMembership;
};

export type IOrderModel = {
  buyerName: string;
  buyerMail: string;
  buyerNote?: string | null;
  buyerId: string;
  orderId: number;
  totalPrice: number;
  formattedTotalPrice: string;
  formattedTaxPrice: string;
  formattedShippingPrice: string;
  formattedSubTotalPrice: string;
  formattedDiscount: string;
  formattedTotalGiftCardAmount: string;
  hasGiftCard: boolean;
  totalGiftCardAmount: number;
  formattedTotalPaid?: string;
  formattedTotalBalance?: string;
  shippingPrice: number;
  taxPrice: number;
  paymentMethod: string;
  payments?: GetOrderForTypQuery['order']['transactions']['payments'];
  paymentStatus: string;
  billingAddress?: BillingAddress;
  shippingAddress: ShippingAddress;
  hasShippingCountryNameTranslation(): boolean;
  deliveryType: string;
  storePickup: StorePickup;
  couponCode: string;
  items: Item[];
  createdDate: number;
  cartId: string;
  checkoutId: string;
  isValid: boolean;
  subscriptionFrequency: SubscriptionFrequency;
  subscriptionDuration: number;
  subscriptionName: string;
  subscriptionInterval: number;
  additionalFees?: Partial<AdditionalFee>[];
  formattedAdditionalFeesPrice?: string;
  additionalFeesPrice?: number;
};

export enum PaymentStatus {
  Paid = 'paid',
  NotPaid = 'notPaid',
  PartiallyPaid = 'partiallyPaid',
}

export enum PaymentMethod {
  Offline = 'offline',
  Online = 'online',
  Stripe = 'Stripe',
}

export type ITYPStyleSettings = {
  booleans: {
    [StyleParam.ShowOrderNumber]: boolean;
    [StyleParam.ShowImage]: boolean;
    [StyleParam.ShowContinueBrowsingLink]: boolean;
  };
};

export type ICartPublicData = Partial<{[k in keyof ISettingsParams]: string | {}}>;
